"use strict";

exports.__esModule = true;
exports.cardTitleMenuPropTypes = exports.cardTitlePropTypes = exports.cardStatusPropTypes = exports.cardImagePropTypes = exports.cardFooterPropTypes = exports.cardDividerPropTypes = exports.cardBlockPropTypes = exports.cardActionsPropTypes = exports.cardPropTypes = void 0;

var _propTypes = require("prop-types");

var _propTypes2 = require("../Menu/propTypes");

var _constants = require("./constants");

var variant = (0, _propTypes.oneOf)(Object.keys(_constants.VARIANT));
var cardPropTypes = {
  children: _propTypes.node.isRequired,
  onClick: _propTypes.func
};
exports.cardPropTypes = cardPropTypes;
var cardActionsPropTypes = {
  children: _propTypes.node.isRequired
};
exports.cardActionsPropTypes = cardActionsPropTypes;
var cardBlockPropTypes = {
  children: _propTypes.node.isRequired
};
exports.cardBlockPropTypes = cardBlockPropTypes;
var cardDividerPropTypes = {};
exports.cardDividerPropTypes = cardDividerPropTypes;
var cardFooterPropTypes = {
  children: _propTypes.node,
  defaultIsOpen: _propTypes.bool,
  expandable: _propTypes.bool,
  isOpen: _propTypes.bool,
  onClose: _propTypes.func,
  onOpen: _propTypes.func,
  title: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  triggerTitle: _propTypes.func,
  variant: variant
};
exports.cardFooterPropTypes = cardFooterPropTypes;
var cardImagePropTypes = {};
exports.cardImagePropTypes = cardImagePropTypes;
var cardStatusPropTypes = {
  children: _propTypes.string.isRequired,
  variant: variant
};
exports.cardStatusPropTypes = cardStatusPropTypes;
var cardTitlePropTypes = {
  actions: _propTypes.node,
  avatar: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  children: _propTypes.node.isRequired,
  secondaryText: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  subtitle: _propTypes.node,
  variant: variant
};
exports.cardTitlePropTypes = cardTitlePropTypes;
var cardTitleMenuPropTypes = {
  data: _propTypes2.menuItemsPropType.isRequired,
  triggerTitle: _propTypes.string
};
exports.cardTitleMenuPropTypes = cardTitleMenuPropTypes;